import { AST } from '@handlebars/parser';
import { isNull } from 'utils/tsHelpers';
import { getPathFromMustacheStatement } from './getPathFromMustacheStatement';
import { isSnippetPath } from './isSnippetPath';

export const getSnippetMustacheStatement = (mustacheStatement: AST.MustacheStatement | null) => {
  const path = getPathFromMustacheStatement(mustacheStatement);
  return !isNull(mustacheStatement) && isSnippetPath(path) ? mustacheStatement : null;
};
